import React, { useState, useEffect } from 'react'
import { Form, Modal, Input, Button, Upload, Image, message } from 'antd'
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { uploadImage } from '../../../services/apiServices'
import CodeEditor from '../../../commons/Editor/CodeEditor'
import RowLayout from './../../RowLayout/RowLayout'
import LoadingModal from './../Loading'

const { TextArea } = Input

const Container = styled.div`
    .image-wrapper {
        display: inline-block;
        padding: 20px;
        margin-top: 15px;
        border: 1px dashed #ccc;
        > img {
            max-width: 400px;
        }
    }
`

const BannerEditorModal = ({ T, isOpen, onCancel, onOk, info = {} }) => {
    let [coverImage, setCoverImage] = useState(info.cover_image)
    let [isLoading, setIsLoading] = useState(false)

    const [form] = Form.useForm()

    useEffect(() => {
        if (isOpen) {
            setCoverImage(info.cover_image)
            form.setFieldsValue({
                topBannerCode: info.top_banner_code,
                bottomBannerCode: info.bottom_banner_code
            })
        }
    }, [isOpen])

    function onFinish(values) {
        let data = {
            cover_image: coverImage,
            top_banner_code: values.topBannerCode,
            bottom_banner_code: values.bottomBannerCode
        }
        onOk && onOk(data)
    }

    async function onUploadImage(file, onSuccess) {
        setIsLoading(true)
        try {
            let { image } = await uploadImage({ body: { file } })
            setIsLoading(false)
            onSuccess && onSuccess(image)
        } catch (error) {
            setIsLoading(false)
            message.error(T('SOMETHING_WRONG'))
        }
    }

    function onChangeCoverImage(e) {
        onUploadImage(e.file.originFileObj, image => setCoverImage(image))
    }

    function onRemoveCoverImage() {
        setCoverImage('')
    }

    return (
        <Modal
            form={form}
            width={640}
            title={T('BANNER')}
            visible={isOpen}
            centered
            okText={T('SAVE')}
            cancelText={T('CANCEL')}
            onOk={() => {
                form.validateFields()
                    .then(values => {
                        form.resetFields()
                        onFinish(values)
                    })
                    .catch(err => {
                        console.log('Validate Failed:', err)
                    })
            }}
            onCancel={() => onCancel()}>
            <Container>
                <Form form={form}>
                    <RowLayout title={T('COVER_IMAGE')} contentSpan={16}>
                        <Form.Item>
                            <div>
                                <div
                                    style={{
                                        display: 'inline-block',
                                        marginRight: 10
                                    }}>
                                    <Upload
                                        accept="image/gif, image/jpeg, image/png, image/webp"
                                        fileList={[]}
                                        customRequest={() => {}}
                                        onChange={onChangeCoverImage.bind(
                                            this
                                        )}>
                                        <Button
                                            type="primary"
                                            icon={<UploadOutlined />}>
                                            {T('UPLOAD')}
                                        </Button>
                                    </Upload>
                                </div>
                                {coverImage && (
                                    <Button
                                        type="primary"
                                        danger
                                        style={{
                                            display: 'inline-block',
                                            marginRight: 5
                                        }}
                                        icon={<DeleteOutlined />}
                                        onClick={() => onRemoveCoverImage()}>
                                        {T('REMOVE')}
                                    </Button>
                                )}
                            </div>
                            {coverImage && (
                                <div className="image-wrapper">
                                    <Image key={coverImage} src={coverImage} />
                                </div>
                            )}
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('TOP_BANNER_CODE')} contentSpan={16}>
                        <Form.Item name="topBannerCode">
                            <CodeEditor />
                        </Form.Item>
                    </RowLayout>
                    <RowLayout title={T('BOTTOM_BANNER_CODE')} contentSpan={16}>
                        <Form.Item name="bottomBannerCode">
                            <CodeEditor />
                        </Form.Item>
                    </RowLayout>
                </Form>

                <LoadingModal isOpen={isLoading} />
            </Container>
        </Modal>
    )
}

export default BannerEditorModal
